<template>
  <div class="input-wrapper">
    <input
      class="form-input-internal"
      :value="value"
      @input="updateValue"
      v-bind="$attrs"
      v-on="listeners"
      @keydown="handleOnKeydown"
      :class="{ 'form-input-internal--error': error }"
    />
    <span class="form-input-internal--bar"></span>
    <label
      class="form-label-internal"
      v-if="label"
      :class="{ 'form-label-internal--error': error }"
      >{{ label }}</label
    >
    <span
      class="form-append-text"
      v-if="appendText"
      @click="$emit('click-append')"
    >
      {{ appendText }}
    </span>
    <div class="form-text-validation form-text-validation--error" v-if="error">
      <span class="text-validation">
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script>
import { formField } from '../../mixins/formField.js';

export default {
  props: {
    postFix: String,
    errorMessage: {
      type: String,
      default: null,
    },
    error: {
      default: false,
      type: Boolean,
    },
    appendText: String,
  },
  mixins: [formField],
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue,
      };
    },
  },
};
</script>
